<template>
  <v-app id="app" class="Kanit">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.Kanit {
  font-family: 'Kanit', sans-serif !important;
}
.custom-swal-font {
  font-family: 'Kanit', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue